import React from 'react';
import { Save, RotateCcw } from 'lucide-react';

interface Props {
  onSave: () => void;
  onDiscard: () => void;
}

export default function SaveBar({ onSave, onDiscard }: Props) {
  return (
    <div className="save-bar">
      <div className="save-bar-msg">
        <div className="save-bar-dot" />
        Alterações não salvas
        <span className="save-bar-hint">· Ctrl+S para salvar</span>
      </div>
      <div className="save-bar-actions">
        <button className="btn-discard" onClick={onDiscard}>
          <RotateCcw size={13} />
          Descartar
        </button>
        <button className="btn-save" onClick={onSave}>
          <Save size={13} />
          Salvar
        </button>
      </div>
    </div>
  );
}
